function LogoutIcon() {
  return (
    <span className="anticon ant-menu-item-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fill="#A9A9A9"
          stroke="#A9A9A9"
          d="M8.658 16.553v-.002a.25.25 0 0 1 .23-.273c.13-.013.26.09.274.23.151 1.633.622 2.87 1.643 3.677 1.003.792 2.437 1.085 4.315 1.085h.13c2.07 0 3.62-.36 4.635-1.375s1.375-2.565 1.375-4.635V8.74c0-2.07-.36-3.62-1.375-4.635S17.32 2.73 15.25 2.73h-.13c-1.888 0-3.33.298-4.333 1.105-1.019.82-1.483 2.075-1.624 3.732a.3.3 0 0 1-.095.181.24.24 0 0 1-.182.054h-.01a.25.25 0 0 1-.227-.273C8.812 5.62 9.4 4.33 10.4 3.503c1.011-.837 2.53-1.273 4.71-1.273h.13c2.397 0 3.99.515 4.993 1.517C21.235 4.75 21.75 6.343 21.75 8.74v6.52c0 2.397-.515 3.99-1.517 4.993-1.003 1.002-2.596 1.517-4.993 1.517h-.13c-2.165 0-3.676-.429-4.685-1.252-.998-.815-1.59-2.086-1.767-3.965Z"
        ></path>
        <path
          fill="#A9A9A9"
          stroke="#A9A9A9"
          d="M14.88 12.25H2a.256.256 0 0 1-.25-.25c0-.134.116-.25.25-.25h12.88c.134 0 .25.116.25.25 0 .138-.11.25-.25.25Z"
        ></path>
        <path
          fill="#A9A9A9"
          stroke="#A9A9A9"
          d="m15.294 12.353.353-.353-.353-.354-2.82-2.82a.255.255 0 0 1 0-.353.255.255 0 0 1 .352 0l3.35 3.35a.254.254 0 0 1 0 .353l-3.35 3.35a.24.24 0 0 1-.176.074.24.24 0 0 1-.176-.074.255.255 0 0 1 0-.353z"
        ></path>
      </svg>
    </span>
  );
}

export default LogoutIcon;
